module.exports = __webpack_public_path__ + "static/media/icon-1year-maintenance.73f22180.svg";